import { pick } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';

import {
  StoreProvider,
  Label,
  ErrorFlash,
  ImageUploader,
} from '../../components';
import { createHappening } from '../../mutations';
import { HOURS, START_OF_DAY, END_OF_DAY } from '../constants';
import 'react-datepicker/dist/react-datepicker.css';
import DatePresenter from '../../presenters/DatePresenter';

export class HappeningNewView extends Component {
  state = {
    title: '',
    url: '',
    backgroundImage: null,
    errors: null,
    startDate: moment().startOf('day').toDate(),
    startTime: START_OF_DAY,
    endDate: moment().startOf('day').toDate(),
    endTime: END_OF_DAY,
    description: '',
    storeId: '',
    details: '',
    callToAction: '',
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { lists, relay } = this.props;
    const attributes = pick(this.state, [
      'title',
      'url',
      'imageUrl',
      'backgroundImage',
      'description',
      'storeId',
      'details',
      'callToAction',
    ]);

    attributes['startDate'] = moment(this.state.startDate)
      .hour(this.state.startTime)
      .minutes(0)
      .toDate();
    attributes['endDate'] = moment(this.state.endDate)
      .hour(this.state.endTime)
      .minutes(0)
      .toDate();

    createHappening(relay.environment, attributes, lists.id, {
      onCompleted: this.handleSubmitSuccess,
    });
  };

  handleSubmitSuccess = (transaction) => {
    let { errors } = transaction.createHeroOffer;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push('/happenings/tab/active');
    }
  };

  // update events
  handleUpdateTitle = (event) => {
    this.setState({ title: event.target.value });
  };

  handleUpdateUrl = (event) => {
    this.setState({ url: event.target.value });
  };

  handleUpdateDescription = (event) => {
    this.setState({ description: event.target.value });
  };

  handleUpdateDetails = (event) => {
    this.setState({ details: event.target.value });
  };

  handleUpdateCallToAction = (event) => {
    this.setState({ callToAction: event.target.value });
  };

  handleImageUploaded = (image) => {
    this.setState({ backgroundImage: image });
  };

  handleStartDate = (date) => {
    if (date !== null) {
      this.setState({ startDate: date });
    }
  };

  handleStartTime = (event) => {
    let hour = event.target.value;
    this.setState({ startTime: hour });
  };

  handleEndDate = (date) => {
    if (date !== null) {
      this.setState({ endDate: date });
    }
  };

  handleEndTime = (event) => {
    let hour = event.target.value;
    this.setState({ endTime: hour });
  };

  handleUpdateStore = (event) => {
    this.setState({ storeId: event.target.value });
  };

  render() {
    let stores = this.props.lists.stores.edges.map((e) => e.node);
    const { errors } = this.state;

    return (
      <div className="happening-new">
        <form className="happening-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>New Happening</h2>
            <div className="form-header-actions">
              <input
                id="saveHappening"
                className="happening-edit-submit"
                type="submit"
                value="Save"
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="form-group">
              <h3>General</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <div className="input">
                    <Label attr="title" text="Title" errors={errors} />
                    <input
                      type="text"
                      id="title"
                      value={this.state.title}
                      onChange={this.handleUpdateTitle}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label
                      attr="description"
                      text="Description"
                      errors={errors}
                    />
                    <input
                      type="text"
                      id="description"
                      value={this.state.description}
                      onChange={this.handleUpdateDescription}
                    />
                  </div>

                  <div className="input">
                    <Label attr="url" text="Url" errors={errors} />
                    <input
                      type="text"
                      id="url"
                      value={this.state.url}
                      onChange={this.handleUpdateUrl}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label attr="store" text="Store" errors={errors} />
                    <select
                      id="store"
                      value={this.state.storeId}
                      onChange={this.handleUpdateStore}
                    >
                      <option value=""> -- select a store -- </option>
                      {stores.map((store, i) => (
                        <option value={store.id} key={i}>
                          {store.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="input">
                    <Label
                      attr="callToAction"
                      text="Call To Action"
                      errors={errors}
                    />
                    <input
                      type="text"
                      id="callToAction"
                      value={this.state.callToAction}
                      onChange={this.handleUpdateCallToAction}
                    />
                  </div>

                  <div className="input">
                    <Label attr="details" text="Details" errors={errors} />
                    <textarea
                      id="details"
                      value={this.state.details}
                      onChange={this.handleUpdateDetails}
                    />
                  </div>
                </div>

                <div className="form-group-column">
                  <div className="input image-upload">
                    <Label
                      attr="backgroundImage"
                      text="Image"
                      errors={errors}
                    />
                    <div className="image-upload-hint">
                      {"Image should be a .png or .jpg and be '750x200'"}
                    </div>
                    <ImageUploader
                      id="backgroundImage"
                      onUploaded={this.handleImageUploaded}
                      cover
                      source={this.state.imageUrl}
                      type="happening"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              <h3>Availability</h3>
              <div className="availability">
                <div className="availability-field start-date">
                  <Label attr="startDate" text="Start Date" errors={errors} />
                  <DatePicker
                    id="startDate"
                    selected={DatePresenter.dateObject(this.state.startDate)}
                    onChange={(date) => this.handleStartDate(date)}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <div className="availability-field start-time">
                  <div>
                    <Label attr="startTime" text="Start Time" />
                    <select
                      id="startTime"
                      value={this.state.startTime}
                      onChange={this.handleStartTime}
                    >
                      {HOURS.map((hour, i) => (
                        <option value={i + 1} key={i}>
                          {hour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="availability-field end-date">
                  <Label attr="endDate" text="End Date" errors={errors} />
                  <DatePicker
                    id="endDate"
                    selected={DatePresenter.dateObject(this.state.endDate)}
                    onChange={(date) => this.handleEndDate(date)}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <div className="availability-field end-time">
                  <div>
                    <Label attr="endTime" text="End Time" />
                    <select
                      id="endTime"
                      value={this.state.endTime}
                      onChange={this.handleEndTime}
                    >
                      {HOURS.map((hour, i) => (
                        <option value={i + 1} key={i}>
                          {hour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const HappeningNewContainer = withRouter(
  createFragmentContainer(HappeningNewView, {
    lists: graphql`
      fragment HappeningNew_lists on Lists {
        id
        stores(first: 1000) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  })
);

export default class HappeningsList extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={HappeningNewContainer}
        query={graphql`
          query HappeningNewQuery {
            lists {
              ...HappeningNew_lists
            }
          }
        `}
      />
    );
  }
}
